import { render } from "./association.vue?vue&type=template&id=76bef920&scoped=true"
import script from "./association.vue?vue&type=script&setup=true&lang=js"
export * from "./association.vue?vue&type=script&setup=true&lang=js"

import "./association.vue?vue&type=style&index=0&id=76bef920&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76bef920"],['__file',"src/views/exhibitionManage/association.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76bef920"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76bef920', __exports__)) {
    console.log('reload')
    api.reload('76bef920', __exports__)
  }
  
  module.hot.accept("./association.vue?vue&type=template&id=76bef920&scoped=true", () => {
    console.log('re-render')
    api.rerender('76bef920', render)
  })

}


export default __exports__